import styled from 'styled-components'
import Colors from '../../constants/Colors'

export const AdjustColumns = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  h3 {
    margin: 0;
  }
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '8px')};
`
export const Hr = styled.hr`
  margin-top: 10px;
`
export const Price = styled.span`
  font-size: 16px;
  color: ${Colors.LIGHT_RED};
`
export const Input = styled.input`
  width: 100%;
  height: 45px;
  padding-left: 5px;
  color: ${Colors.DARK_GREY};
  border: 1px solid ${Colors.LIGHT_GREY2};
`
export const Button = styled.div`
  padding: 20px 0;
  flex: 1;
  text-align: center;
  &:hover {
    cursor: pointer;
    box-shadow:
      rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
      rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  }
  box-shadow: rgba(0, 0, 0, 0.8) 1.95px 1.95px 2.6px;
  color: ${Colors.WHITE};
  background-color: ${({ bgColor }) => bgColor};
`
